import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  environment: 'development',
  
  // API Configuration
  //baseUrl: 'https://apps.myfleetman.in/MFMUATAPI',
  baseUrl : "",
  avenueUrl: '',
  razorPayKey: '',
  
  // App Configuration
  appName: 'MyFleetMan',
  version: '1.0.0',
  
  // Debug and Development
  debug: true,
  logLevel: 'debug',
  enableConsoleLogs: true,
  enableSourceMaps: true,
  
  // Features
  showGoogleMapAddress: false,
  enableAnalytics: false,
  enableErrorReporting: false,
  
  // Network
  timeout: 30000,
  retryAttempts: 3,
  
  // Security
  enableCSP: false,
  enableHSTS: false,
  enableSecureCookies: false
}; 
